import React, { useState, useEffect } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import AuthBtn from "../Buttons/AuthBtn";
import { fetchStockStats } from "../../store/Slices/StockStatsSlice";
import { fetchSupplierInvoice } from "../../store/Slices/SupplierInvoiceSlice";
import ItemSelector from "../Selector/ItemSelector";
import CompanySelector from "../Selector/CompanySelector";
import { UpdateCompanyInvoiceApi } from "../../ApiRequests";
import { toLocalYmd } from "../../utils/dateTime";

const EditStockModal = ({ Open, setOpen, stockDetail, supplierId }) => {
  const [invoiceNo, setInvoiceNo] = useState(stockDetail.invoice_no);
  const [truckNo, setTruckNo] = useState(stockDetail.truck_no);
  const [qty, setQty] = useState(stockDetail.qty);
  const [desc, setDesc] = useState(stockDetail.desc);
  const [CurDate, setCurDate] = useState(
    toLocalYmd(stockDetail.date)
  );
  const [loading, setLoading] = useState(false);
  const [SelectedProduct, setSelectedProduct] = useState(stockDetail.itemId);
  const [SelectedCompany, setSelectedCompany] = useState(stockDetail.companyId);

  const dispatch = useDispatch();

  useEffect(() => {
    setInvoiceNo(stockDetail.invoice_no);
    setTruckNo(stockDetail.truck_no);
    setQty(stockDetail.qty);
    setDesc(stockDetail.desc);
    setCurDate(
      toLocalYmd(stockDetail.date)
    );
    setSelectedProduct(stockDetail.itemId);
    setSelectedCompany(stockDetail.companyId);
  }, [stockDetail]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!SelectedCompany?._id) WarningToast("Select a company");
    else if (!SelectedProduct?._id) WarningToast("Select an Item");
    else if (!qty || isNaN(qty)) WarningToast("Enter a valid Quantity");
    else if (!CurDate) WarningToast("Select a Date");
    else {
      try {
        const purchase = Number(SelectedProduct.purchase);
        const qtyNum = Number(qty);
        const companyId =
          SelectedCompany._id ||
          (SelectedProduct.companyId &&
          typeof SelectedProduct.companyId === "object"
            ? SelectedProduct.companyId._id
            : SelectedProduct.companyId);

        const payload = {
          itemId: SelectedProduct._id,
          companyId,
          qty: qtyNum,
          purchase,
          total_amount: purchase * qtyNum,
          invoice_no: Number(invoiceNo),
          truck_no: String(truckNo || "").trim(),
          date: Math.floor(new Date(CurDate).getTime() / 1000),
          desc: (desc && String(desc).trim()) || "-",
          branchId: stockDetail.branchId,
        };

        const response = await UpdateCompanyInvoiceApi(
          stockDetail._id,
          payload
        );

        if (response.data.success) {
          setOpen(false);
          SuccessToast("Stock updated successfully");
          dispatch(fetchStockStats());
          dispatch(
            fetchSupplierInvoice(supplierId || undefined)
          );
        } else {
          ErrorToast(response.data.error?.msg || "Server error");
        }
      } catch (err) {
        console.error(err);
        ErrorToast(
          err.response?.data?.error?.msg ||
            err.message ||
            "Failed to update stock"
        );
      }
    }

    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Edit Invoice
        </h1>
        <div className="flex flex-col gap-y-4 px-10">
          <CompanySelector
            SelectedSupplier={SelectedCompany}
            setSelectedSupplier={setSelectedCompany}
          />

          <ItemSelector
            setSelectedProduct={setSelectedProduct}
            SelectedProduct={SelectedProduct}
            SelectedCompany={SelectedCompany}
          />

          <AuthInput
            label="Invoice No"
            placeholder="Enter Invoice No"
            Value={invoiceNo}
            setValue={setInvoiceNo}
            Type={"number"}
          />
          <AuthInput
            label="Truck No"
            placeholder="Enter Truck No"
            Value={truckNo}
            setValue={setTruckNo}
          />
          <AuthInput
            label="Quantity"
            placeholder="Enter Quantity"
            Type="number"
            Value={qty}
            setValue={setQty}
          />
          <AuthInput
            label="Description"
            placeholder="Enter Description"
            Value={desc}
            setValue={setDesc}
          />
          <AuthInput
            label="Date"
            placeholder="Select Date"
            Type="date"
            Value={CurDate}
            setValue={setCurDate}
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Edit Stock"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default EditStockModal;
